export const NONE = 'none';
export const LOADING = 'loading';
export const UPDATING = 'updating';
export const SUCCEEDED = 'succeeded';
export const FAILED = 'failed';
export const LOADED = 'loaded';
